import { render, staticRenderFns } from "./404.vue?vue&type=template&id=d4641136&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=d4641136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4641136",
  null
  
)

component.options.__file = "404.vue"
export default component.exports